import styled from 'styled-components'

export const MiniAppDiffTable = styled.table`
    border: 1px solid #cccc;
    & tr {
        border-bottom: 1px solid #cccc;
    }
    & th {
        font-weight: bolder;
        text-align: center;
        padding: 7px;
    }
    & td {
        text-align: center;
        padding: 5px;
        vertical-align: top;
        border-top: 0;
    }
`

export const MiniAppTitle = styled.div`
    font-size: 23px;
    margin: 0 0 12px 0;
`
export const ToggleTag = styled.a`
    font-family: monospace;
`
export const TitleHelper = styled.span`
    font-size: 16px;
`
